import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {AutoRoutingService} from '../../../../services/auto-routing.service';
import {T2LoadingService} from '../../../../trip2-theme/components/t2-loading/t2-loading.service';

@Component({
  selector: 'app-assign-trip',
  templateUrl: './assign-trip.component.html',
  styleUrls: ['./assign-trip.component.scss']
})
export class AssignTripComponent implements OnInit {

  @Input() tripid?: number;
  @Input() jobId?: number;
  @Input() driver?: any[] = [];
  @Output() onClose?: EventEmitter <any> = new EventEmitter <any>();
  public disableCard = false;

  ScheduleId: number;

  constructor(
    private _autoRoutingService: AutoRoutingService,
    private _loading: T2LoadingService
  ) { }

  ngOnInit() {
  }

  onSave() {
    this._loading.show();
    this.disableCard = true;
    const obj = {
      'AutoRoutingJobId': this.jobId,
      'ScheduleId': this.ScheduleId,
      'TripId': this.tripid
    };
    this._autoRoutingService
      .postAssign(obj)
      .finally(() => {
        this._loading.hiden();
        this.onClose.emit(this.ScheduleId);
      })
      .subscribe(
      data => {
        // this.onClose.emit(true);
      }, error => {
        alert(JSON.stringify(error));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/components/assign-trip/assign-trip.component.ts